import React from "react";

const Total = (props) => {
    return (
        <div>
            <div class="container">
                <div class="row">
                    <div className="row customer-support text-center" style={{ marginTop: 10 }}>
                        <h4 style={{ color: "black" }}>{props.VehEntry.Veh_Year} {props.VehEntry.Veh_Make} {props.VehEntry.Veh_Model}</h4>
                        <p style={{ marginTop: 10, color: "black" }}>Total Loss</p>
                        <p><b>{props.Veh_Year}</b></p>
                    </div>
                </div>
            </div>
            <div className="sec-title text-left" style={{ marginTop: 10 }}>
                <h4 style={{ color: "black" }}>What does this mean?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>We have been notified by your insurance company that they are considering your vehicle a total loss. This usually means that the estimated cost of repairs excedes approximatley 75% of the current value of the vehicle. Ark-La-Tex Collision does not have the authority to consider a vehicle a total loss. This decision is made by your insurance company.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>What is next?</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>Your insurance company will reach out to you soon to discuss the next steps.</p>
            </div>
            <div className="sec-title text-left">
                <h4 style={{ color: "black" }}>Estimated Completion Date</h4>
                <span className="decor" />
                <p style={{ color: "black" }}>The vehicle has been considered a total loss by insurance. No additional work will be done.</p>
            </div>
        </div>
    )
}

export default Total